import {useAppContext} from "../../Context/ProjectContextV2";
import {useEffect} from "react";

export default function UITab() {
    const {getSelectedRS, selectedRS, getOperationItemConfig} = useAppContext()

    return (
        <div style={{marginTop: 16}}>
            {getOperationItemConfig()?.UI?.Component(getSelectedRS())}
        </div>
    )
}